// Client-side payment-terms predicate for the /ar list filter row.
//
// `termsById` maps a customerId to its recorded payment-terms code
// (e.g. 'N30', 'N60'). When the filter is empty every row passes; otherwise a
// row passes only when its customer's terms exactly match the selected filter.
// A customer with no recorded terms never matches a non-empty filter.
export function matchesTerms(
  customerId: string,
  termsFilter: string,
  termsById: Map<string, string>,
): boolean {
  if (!termsFilter) return true;
  return (termsById.get(customerId) ?? '') === termsFilter;
}
